import { useEffect } from 'react';
import '../../../../shared/src/common/css/scheduler.css';
import SchedulerSteps from '@leadflow/shared/src/feature/scheduler/components/SchedulerStep/SchedulerSteps';
import ThemeProviderWrapper from '../../theme/ThemeContext';
import { SchedulerConfig } from '@leadflow/shared/src/Interface/scheduler/form';
import { FormProvider } from '@leadflow/shared/src/common/contexts/FormContext';
import { SharedStateProvider } from '@leadflow/shared/src/common/contexts/SharedStateContext';
import { useFormConfigContext } from '@leadflow/shared/src/common/contexts/FormConfigContext';
import { schedulerConfigJsonSequence } from '@leadflow/shared/src/common/components/Helper/Helper';

interface HTMLElementWithContent extends HTMLElement {
  textContent: string;
}

const App = () => {
  const { setFormConfig } = useFormConfigContext();
  useEffect(() => {
    const fspInlineFormConfig = document.getElementById(
      'data',
    ) as HTMLElementWithContent | null;
    if (fspInlineFormConfig?.textContent) {
      try {
        const fspJsonData = JSON.parse(
          fspInlineFormConfig.textContent,
        ) as SchedulerConfig;
        if (fspJsonData?.conceptid) {
          const formatData = schedulerConfigJsonSequence(fspJsonData);
          setFormConfig(formatData);
        }
      } catch (error) {
        console.error('Failed to parse JSON:', error);
      }
    } else {
      fetch('/config-files/_scheduler-config.json')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((fspData) => {
          if (fspData?.steps) {
            const formatData = schedulerConfigJsonSequence(fspData);
            setFormConfig(formatData);
          }
        })
        .catch((error) => console.error('Error fetching FSP config:', error));
    }
  }, []);

  return (
    <ThemeProviderWrapper>
      <FormProvider>
        <SharedStateProvider>
          <SchedulerSteps />
        </SharedStateProvider>
      </FormProvider>
    </ThemeProviderWrapper>
  );
};

export default App;
